import type { Product } from 'models/product';
import type { ProductCard } from 'models/productCard';
import { getMainImageDetail, getProductImage } from 'utils/business-logic';
import { filterTruthy } from 'utils/collection';

import { useStockContext } from '../ProductDetailsContext';

import BasePicker from './BasePicker';

interface Props {
	className?: string;
	fallbackButtonText: string;
	fallbackPopoverTitle: string;
	product: Product;
	variants: ProductCard[] | undefined;
}

export default function VariantPicker({
	className,
	fallbackButtonText,
	fallbackPopoverTitle,
	product,
	variants,
}: Props) {
	const { isLoadingVariantsStock, loadVariantsStock, variantsStock } =
		useStockContext();

	return (
		<BasePicker
			className={className}
			buttonLabel={
				product.multipleVariantNaming?.pickerText || fallbackButtonText
			}
			popoverTitle={
				product.multipleVariantNaming?.pickerText || fallbackPopoverTitle
			}
			onOpen={() => {
				loadVariantsStock();
			}}
			selectedText={product.variantText}
			selectedImageUrl={getMainImageDetail(product)?.src}
			stockData={variantsStock}
			stockIsLoading={isLoadingVariantsStock}
			variants={filterTruthy(variants, 'url').map((variant) => {
				const image = getProductImage(variant);

				return {
					imageSrc: image?.src,
					imageAlt: image?.alt,
					isSelected: variant.id === product.id,
					isSellable: variant.isSellable,
					isSellableOnWeb: variant.isSellableOnWeb,
					key: variant.id,
					price: variant.displayPrice,
					title: variant.variantText,
					url: variant.url,
					variantId: variant.id,
				};
			})}
		/>
	);
}
VariantPicker.displayName = 'ProductDetails_VariantPicker';
